import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, useAdminApi } from "@/lib/api";
import RecordForm from "./RecordForm";

const FIELDS = [
  { name: "announcement_bar", label: "Announcement bar (top of every page, leave blank to hide)", type: "text" },
  { name: "trial_announcement", label: "Trial announcements (Players page)", type: "textarea" },
  { name: "eligibility", label: "Player eligibility information (Players page)", type: "textarea" },
  { name: "show_news_on_home", label: "Show latest news on homepage", type: "checkbox" },
  { name: "show_sponsors_on_home", label: "Show sponsorship section on homepage", type: "checkbox" },
];

export default function SettingsPage() {
  const req = useAdminApi();
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setV({ hero_note: "", ...r.data })); }, []);
  const save = async () => {
    try { setV(await req("put", "/admin/settings", v)); toast.success("Settings saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!v) return null;
  return (
    <div data-testid="admin-settings" className="max-w-3xl space-y-6">
      <h1 className="font-display text-4xl uppercase">Homepage & announcements</h1>
      <div className="rounded-md border border-white/10 bg-[#112240] p-6"><RecordForm fields={FIELDS} value={v} onChange={setV} teams={[]} venues={[]} /></div>
      <button type="button" onClick={save} data-testid="settings-save-btn" className="rounded-full bg-[#00E5FF] px-6 py-2.5 text-xs font-bold uppercase tracking-wider text-[#0A192F]">Save settings</button>
    </div>
  );
}
